import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import Header from './components/Header';
import Gallery from './components/Gallery';
import SearchResults from './components/SearchResults';
import ImageDetail from './components/ImageDetail';
import Upload from './components/Upload';
import DropboxSync from './components/DropboxSync';
import Albums from './components/Albums';
import AlbumView from './components/AlbumView';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <PrivateRoute>
        <Box sx={{
          minHeight: '100vh',
          backgroundColor: '#000000',
        }}>
          <Header />
          <Container maxWidth="xl" sx={{ py: 3 }}>
            <Routes>
              <Route path="/" element={<Gallery />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/image/:id" element={<ImageDetail />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/sync" element={<DropboxSync />} />
              <Route path="/albums" element={<Albums />} />
              <Route path="/albums/:albumId" element={<AlbumView />} />
            </Routes>
          </Container>
        </Box>
      </PrivateRoute>
    </AuthProvider>
  );
}

export default App;